import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiParameter, ServiceResult, get, post } from "@insite/client-framework/Services/ApiService";

export interface VisualFilterCarousal {
    uri: any;
    visualFilterCollectionID: string;
    categoryName: any;
    subCategoryName: any;
    visualFilters: VisualFilter[];
    pageURL: string;
    validFrom: string;
    validTo: string;
    isAdminView: boolean;
    properties: Properties;
}

export interface categoryId {
    categoryId: string;
    shortDescription: string;
}

export interface VisualFilter {
    visualFilterID: string;
    categoryID: categoryId;
    filterTitle: string;
    productNumber: string;
    productImage: string;
    attributeFilters: string;
    pageURL: string;
    sort: string;
    pageSize?: any;
    boostIDs?: any;
    searchWithin?: any;
    expand: string;
    isDisabled: boolean;
    isToBeAdded: boolean;
    class?: any;
    dataGaPromo: string;
    visualNavType: number;
    coveoAttributeFilters:string;
    slideNumber:number;
    adiLink:string;
}

export interface Properties { }

export interface visualCarousalParams extends ApiParameter {
    pathUrl?: string;
}

export interface visualNavParams extends ApiParameter {
    uri: any;
    visualFilterCollectionID: string;
    categoryName: any;
    subCategoryName: any;
    visualFilters: VisualFilter[];
    pageURL: string;
    validFrom: string;
    validTo: string;
    isAdminView: boolean;
    properties: Properties;
    onSuccess?: () => void;
    onError?: () => void;
}

export interface validateNumberParams extends ApiParameter {
    adiNumber: string;
}

export interface ValidateNumberModel {
    adiNumber: string;
    imageUrl: string;
    properties: Properties;
    uri: any;
}

const visualCarousalUrl = "/api/v1/visualnavigation/GetVisualNavigationFilters";
const createVisualNavUrl = "/api/v1/visualnavigation/CreateVisualNavigation";
const validateADINumberUrl = "/api/v1/visualnavigation/ValidateADINumber";

export async function getVisualCarousal(parameter: visualCarousalParams) {
    const response = await get<VisualFilterCarousal>(visualCarousalUrl, parameter);
    return response;
}

export async function saveVisualNavService(
    parameter: visualNavParams,
): Promise<ServiceResult<VisualFilterCarousal>> {
    try {
        const response = await post<VisualFilterCarousal>(createVisualNavUrl, parameter) as any;
        return {
            result: response,
            successful: true,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}

export async function validateADINumber(parameter: validateNumberParams) {
    try {
        const response = await get<ValidateNumberModel>(`${validateADINumberUrl}?adiNumber=${parameter.adiNumber}`);
        return response;
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }

}




